(() => {
  const roots = document.querySelectorAll('toggle-cross-sell');
  if (!roots.length) return;
  roots.forEach(init);

  function init($root) {
    /* ---------- Money format ---------- */
    const moneyFormat = (window.Shopify && typeof Shopify.formatMoney === 'function')
      ? (cents) => {
          try {
            const fmt = (window?.theme?.moneyFormat) || "{{ amount_with_comma_separator }}€";
            return Shopify.formatMoney(parseInt(cents || 0, 10), fmt);
          } catch (_) {
            return (parseInt(cents || 0, 10) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
          }
        }
      : (cents) => (parseInt(cents || 0, 10) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

    /* ---------- Remises & options ---------- */
    const pctOne   = parseInt($root.dataset.discountOne  || 0, 10);
    const pctBoth  = parseInt($root.dataset.discountBoth || 0, 10);
    const precheck = String($root.dataset.precheck) === 'true';

    /* ---------- Produit principal ---------- */
    let mainBaseCents    = parseInt($root.dataset.mainPrice   || 0, 10);
    let mainCompareCents = parseInt($root.dataset.mainCompare || 0, 10) || 0;

    const mainPriceEl   = $root.querySelector('[data-main-price]');
    const mainCompareEl = $root.querySelector('[data-main-compare]');
    const mainBadgeEl   = $root.querySelector('[data-main-badge]');
    const mainImg       = $root.querySelector('.cs-main__thumb img');
    const mainVarSel    = $root.querySelector('.cs-main-variant');

    function setMainData(priceCents, compareCents) {
      mainBaseCents    = parseInt(priceCents || 0, 10);
      mainCompareCents = parseInt(compareCents || 0, 10) || 0;
    }

    if (mainVarSel) {
      mainVarSel.addEventListener('change', (e) => {
        const opt = e.target.selectedOptions[0];
        setMainData(opt.dataset.priceCents, opt.dataset.compareCents);
        const url = opt.dataset.variantImage;
        if (url && mainImg) {
          const w = parseInt(opt.dataset.variantImageWidth  || '0', 10);
          const h = parseInt(opt.dataset.variantImageHeight || '0', 10);
          mainImg.src = url;
          if (w && h) { mainImg.setAttribute('width', w); mainImg.setAttribute('height', h); }
        }
        refresh();
      });
    }

    /* ---------- Cartes accessoires ---------- */
    const cards = [...$root.querySelectorAll('.toggle-cross-sell__product')];
    const getCardCheckbox  = (card) => card.querySelector('input[type="checkbox"][data-variant-id]');
    const getCardAddButton = (card) => card.querySelector('button[data-variant-id]');
    const isCardSelected = (card) => {
      const check = getCardCheckbox(card);
      if (check) return !!check.checked;
      const btn = getCardAddButton(card);
      if (btn) return btn.getAttribute('aria-pressed') === 'true';
      return false;
    };

    function normalizeCardPrices(card) {
      const container = card.querySelector('.toggle-cross-sell__product-price-container');
      const p = parseInt(card.dataset.price   || 0, 10);
      const c = parseInt(card.dataset.compare || 0, 10) || 0;
      if (container) {
        container.dataset.priceCents   = p;
        container.dataset.compareCents = c;
      }
    }

    cards.forEach((card) => {
      normalizeCardPrices(card);
      const check = getCardCheckbox(card);
      const btn   = getCardAddButton(card);

      if (precheck) {
        if (check) check.checked = true;
        if (btn) { btn.setAttribute('aria-pressed', 'true'); card.classList.add('is-added'); }
      }

      if (check) check.addEventListener('change', refresh);
      if (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('aria-pressed') || (precheck ? 'true' : 'false'));
        btn.addEventListener('click', () => {
          const next = btn.getAttribute('aria-pressed') !== 'true';
          btn.setAttribute('aria-pressed', String(next));
          card.classList.toggle('is-added', next);
          refresh();
        });
      }

      const select = card.querySelector('.variant-select-input');
      if (select) {
        select.addEventListener('change', (e) => {
          const opt = e.target.selectedOptions[0];
          const price   = parseInt(opt.dataset.priceCents   || 0, 10);
          const compare = parseInt(opt.dataset.compareCents || 0, 10) || 0;
          card.dataset.price = price; card.dataset.compare = compare;

          const container = card.querySelector('.toggle-cross-sell__product-price-container');
          if (container) { container.dataset.priceCents = price; container.dataset.compareCents = compare; }

          const url = opt.dataset.variantImage;
          if (url) {
            const w = parseInt(opt.dataset.variantImageWidth  || '0', 10);
            const h = parseInt(opt.dataset.variantImageHeight || '0', 10);
            const img = card.querySelector('.toggle-cross-sell__product-image img');
            if (img) { img.src = url; if (w && h) { img.setAttribute('width', w); img.setAttribute('height', h); } }
          }
          refresh();
        });
      }
    });

    /* ---------- Rendu prix ---------- */
    function renderCardPrice(container, baseCents, discountPct) {
      if (!container) return { base: 0, discounted: 0 };
      const base = parseInt(baseCents || 0, 10);
      const discounted = discountPct > 0 ? Math.round(base * (100 - discountPct) / 100) : base;
      container.innerHTML = '';
      if (discountPct > 0) {
        const cmp = document.createElement('span'); cmp.className = 'toggle-cross-sell__product-compare-at-price'; cmp.textContent = moneyFormat(base); container.appendChild(cmp);
        const strong = document.createElement('strong'); strong.className = 'money toggle-cross-sell__product-price'; strong.textContent = moneyFormat(discounted); container.appendChild(strong);
        const badge = document.createElement('span'); badge.className = 'toggle-cross-sell__product-badge-discount'; badge.textContent = `-${discountPct}%`; container.appendChild(badge);
      } else {
        const strong = document.createElement('strong'); strong.className = 'money toggle-cross-sell__product-price'; strong.textContent = moneyFormat(base); container.appendChild(strong);
      }
      return { base, discounted };
    }

    function renderMainPrice(discountPct) {
      const base = parseInt(mainBaseCents || 0, 10);
      const discounted = discountPct > 0 ? Math.round(base * (100 - discountPct) / 100) : base;
      if (mainPriceEl) mainPriceEl.textContent = moneyFormat(discounted);
      if (mainCompareEl) {
        if (discountPct > 0) { mainCompareEl.textContent = moneyFormat(base); mainCompareEl.style.display = ''; }
        else { mainCompareEl.textContent = ''; mainCompareEl.style.display = 'none'; }
      }
      if (mainBadgeEl) { mainBadgeEl.style.display = discountPct > 0 ? 'inline-block' : 'none'; if (discountPct > 0) mainBadgeEl.textContent = `-${discountPct}%`; }
      return { base, discounted };
    }

    /* ---------- Bandeau total ---------- */
    const totalCompareEl = $root.querySelector('.cs-total__compare');
    const totalBadgeEl   = $root.querySelector('.cs-total__badge');
    const totalPriceEl   = $root.querySelector('.cs-total__price');

    function refresh() {
      const selectedCards = cards.filter(isCardSelected);
      const count = selectedCards.length;
      const bundlePct = count >= 2 ? pctBoth : (count === 1 ? pctOne : 0);

      let totalOriginal   = 0;
      let totalDiscounted = 0;

      const mainRes = renderMainPrice(bundlePct);
      totalOriginal   += mainRes.base;
      totalDiscounted += mainRes.discounted;

      cards.forEach((card) => {
        const container = card.querySelector('.toggle-cross-sell__product-price-container');
        const base = container ? parseInt(container.dataset.priceCents || 0, 10)
                               : parseInt(card.dataset.price || 0, 10);
        const selected = isCardSelected(card);
        const pct = selected ? bundlePct : 0;
        const res = renderCardPrice(container, base, pct);
        if (selected) { totalOriginal += res.base; totalDiscounted += res.discounted; }
      });

      if (totalPriceEl) totalPriceEl.textContent = moneyFormat(totalDiscounted);
      if (totalDiscounted < totalOriginal) {
        if (totalCompareEl) { totalCompareEl.textContent = moneyFormat(totalOriginal); totalCompareEl.style.display = 'inline'; }
        if (totalBadgeEl)   { const pct = Math.round((totalOriginal - totalDiscounted) * 100 / totalOriginal); totalBadgeEl.textContent = `-${pct}%`; totalBadgeEl.style.display = 'inline-flex'; }
      } else {
        if (totalCompareEl) { totalCompareEl.textContent = ''; totalCompareEl.style.display = 'none'; }
        if (totalBadgeEl)   { totalBadgeEl.style.display = 'none'; }
      }
    }
    refresh();

    /* =========================================================
     *               AJOUT AU PANIER (CTA SECTION)
     * ========================================================= */
    const cta = $root.querySelector('.toggle-cross-sell__footer button');
    if (cta) {
      cta.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const items = collectItemsForCart();
        if (!items.length) return;

        setLoading(true);
        try {
          await addItemsToCart(items);                 // 1) ajout
          const cart = await getCartState();           // 2) état
          await refreshCartSections();                 // 3) tiroir + notif
          await refreshHeaderCartBubble(cart?.item_count ?? 0); // 4) *** bulle header ***
          dispatchCartUpdated();                       // 5) events
          openDrawerViaThemeTrigger();                 // 6) ouvre tiroir
        } catch (err) {
          console.warn('Add-to-cart (bundle) error', err);
          openDrawerFallback();
        } finally {
          setLoading(false);
        }
      });
    }

    function setLoading(on) {
      if (!cta) return;
      cta.disabled = !!on;
      cta.setAttribute('aria-busy', on ? 'true' : 'false');
      cta.classList.toggle('is-loading', !!on);
    }

    /* ---------- Build items ---------- */
    const valueAsIntOrNull = (v) => {
      if (v == null) return null;
      const n = parseInt(String(v).replace(/\D+/g, ''), 10);
      return Number.isFinite(n) ? n : null;
    };
    const getSelectedVariantIdFromSelect = (sel) => {
      if (!sel) return null;
      if (sel.value) return valueAsIntOrNull(sel.value);
      const opt = sel.querySelector('option[selected]') || sel.selectedOptions?.[0];
      return opt?.value ? valueAsIntOrNull(opt.value) : null;
    };

    function collectItemsForCart() {
      const items = [];
      const mainVarId = getSelectedVariantIdFromSelect(mainVarSel);
      if (mainVarId) items.push({ id: mainVarId, quantity: 1 });
      cards.forEach((card) => {
        if (!isCardSelected(card)) return;
        let varId = getSelectedVariantIdFromSelect(card.querySelector('.variant-select-input'));
        if (!varId) {
          const cb  = getCardCheckbox(card);
          const btn = getCardAddButton(card);
          varId = valueAsIntOrNull(cb?.dataset.variantId || btn?.dataset.variantId);
        }
        if (varId) items.push({ id: varId, quantity: 1 });
      });
      return items;
    }

    /* ---------- Add to cart + fallbacks ---------- */
    async function addItemsToCart(items) {
      // JSON
      let res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items }),
        credentials: 'same-origin'
      });
      if (res.ok) return res.json();

      // Fallback url-encoded
      const params = new URLSearchParams();
      items.forEach((it, i) => {
        params.append(`items[${i}][id]`, String(it.id));
        params.append(`items[${i}][quantity]`, String(it.quantity || 1));
      });
      res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json' },
        body: params.toString(),
        credentials: 'same-origin'
      });
      if (!res.ok) {
        const txt = await res.text().catch(() => '');
        throw new Error(`Add failed (fallback) HTTP ${res.status} – ${txt}`);
      }
      return res.json();
    }

    async function getCartState() {
      const r = await fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' }});
      if (!r.ok) return null;
      return r.json();
    }

    /* ---------- Re-render sections : tiroir + notif ---------- */
    async function refreshCartSections() {
      const sections = ['cart-drawer', 'cart-notification'];
      const url = `${window.location.pathname}?sections=${sections.join(',')}`;
      let data = null;
      try {
        const r = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Cache-Control': 'no-cache' } });
        if (!r.ok) return;
        data = await r.json();
      } catch { return; }

      const parser = new DOMParser();

      // cart-drawer
      if (data['cart-drawer']) {
        const html = parser.parseFromString(data['cart-drawer'], 'text/html');
        const fresh = html.getElementById('shopify-section-cart-drawer');
        const current = document.getElementById('shopify-section-cart-drawer');
        if (fresh && current) current.replaceWith(fresh);
      }

      // cart-notification (si présent)
      if (data['cart-notification']) {
        const html = parser.parseFromString(data['cart-notification'], 'text/html');
        const fresh = html.getElementById('shopify-section-cart-notification');
        const current = document.getElementById('shopify-section-cart-notification');
        if (fresh && current) current.replaceWith(fresh);
      }
    }

    /* ---------- Header bubble (Fullstack) ---------- */
    async function refreshHeaderCartBubble(count) {
      // Essaye différentes sections de header selon les thèmes
      const trySections = ['header', 'header-group'];
      let data = null;

      for (const sec of trySections) {
        try {
          const r = await fetch(`${window.location.pathname}?sections=${sec}`, {
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Cache-Control': 'no-cache' }
          });
          if (!r.ok) continue;
          const json = await r.json();
          if (json && json[sec]) { data = json[sec]; break; }
        } catch { /* next */ }
      }

      if (!data) { updateCartBubbleFallback(count); return; }

      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');

      // Dans le header rendu, récupère uniquement la bulle pour ne pas toucher au SVG/icône
      const freshWrap = doc.querySelector('#cart-icon-bubble, .header__icon--cart, [data-header-cart]');
      const freshBubble = freshWrap && freshWrap.querySelector('.cart-count-bubble');
      if (!freshBubble) { updateCartBubbleFallback(count); return; }

      const liveWrap = document.querySelector('#cart-icon-bubble, .header__icon--cart, [data-header-cart]');
      if (!liveWrap) { updateCartBubbleFallback(count); return; }

      const currentBubble = liveWrap.querySelector('.cart-count-bubble');
      if (currentBubble) {
        currentBubble.replaceWith(freshBubble.cloneNode(true));
      } else {
        liveWrap.appendChild(freshBubble.cloneNode(true));
      }

      // Aligne les classes/attributs contrôlés par le thème
      if (typeof count === 'number') {
        liveWrap.classList.toggle('has-items', count > 0);
        liveWrap.setAttribute('data-cart-count', String(count));
      }
    }

    function updateCartBubbleFallback(count) {
      const n = Math.max(0, parseInt(count || 0, 10));
      const wrap = document.querySelector('#cart-icon-bubble, .header__icon--cart, [data-header-cart]');
      if (!wrap) return;

      wrap.classList.toggle('has-items', n > 0);
      wrap.setAttribute('data-cart-count', String(n));

      let bubble = wrap.querySelector('.cart-count-bubble');
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        wrap.appendChild(bubble);
      }
      let visible = bubble.querySelector('span[aria-hidden="true"]');
      if (!visible) { visible = document.createElement('span'); visible.setAttribute('aria-hidden','true'); bubble.appendChild(visible); }
      visible.textContent = n;

      let sr = bubble.querySelector('.visually-hidden');
      if (!sr) { sr = document.createElement('span'); sr.className = 'visually-hidden'; bubble.appendChild(sr); }
      sr.textContent = `${n}\u00A0article${n>1?'s':''}`;
    }

    function dispatchCartUpdated() {
      try {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:change',  { bubbles: true }));
      } catch (_) {}
    }

    /* ---------- Ouvrir tiroir ---------- */
    function openDrawerViaThemeTrigger() {
      const triggers = [
        '[data-drawer-trigger][data-drawer-id="cart"]',
        '[data-cart-drawer-toggle]',
        '[data-cart-toggle]',
        '.header__icon--cart a',
        '.header__icon--cart button',
        'button[aria-controls="cart-drawer"]',
        'a[href="#cart-drawer"]',
        'a[href="/cart"]'
      ];
      for (const sel of triggers) {
        const t = document.querySelector(sel);
        if (t) {
          t.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          return;
        }
      }
      openDrawerFallback();
    }

    function openDrawerFallback() {
      const drawer = document.querySelector('cart-drawer, [data-cart-drawer]');
      if (drawer) { drawer.setAttribute('open', ''); drawer.classList.add('is-open', 'active'); }
      document.body.classList.add('cart-drawer-open', 'overflow-hidden');
      try {
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true, detail: { id: 'cart' } }));
      } catch (_) {}
      try { window.CartDrawer && typeof window.CartDrawer.open === 'function' && window.CartDrawer.open(); } catch(_) {}
    }
  }
})();
